import { Outlet } from 'react-router-dom';
import loginBanner from '@/assets/images/login-banner.png';

export function AuthLayout() {
  return (
    <div className="flex h-screen font-sans bg-surface-subtle">
      {/* Left brand panel */}
      <div className="auth-brand-panel hidden lg:flex w-[45%] flex-col justify-between p-10 relative overflow-hidden">
        <img
          src={loginBanner}
          alt="QHRMS"
          className="auth-brand-panel__image absolute inset-0 w-full h-full object-cover"
        />
        <div className="auth-brand-panel__overlay" aria-hidden="true" />
        <div className="relative z-10">
          <div className="text-4xl font-extrabold text-white leading-tight mb-4">
            Your entire HR<br />
            <span className="auth-accent-text">lifecycle, unified.</span>
          </div>
          <p className="text-md text-white/75 leading-relaxed max-w-md">
            From onboarding to payroll, performance to exit - QHRMS gives every
            person in your organization the tools they need.
          </p>
        </div>
        <div className="relative z-10 grid grid-cols-3 gap-3">
          {[
            { label: 'Config Module', sub: 'Setup & Policy' },
            { label: 'Operations', sub: 'HR Management' },
            { label: 'Employee Portal', sub: 'Self-Service' },
          ].map((m) => (
            <div key={m.label} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-3">
              <div className="text-sm font-bold text-white mt-1">{m.label}</div>
              <div className="text-2xs text-white/60 mt-0.5">{m.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Right content */}
      <div className="flex-1 flex items-center justify-center p-8 lg:p-12">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
